import React, { useEffect, useCallback } from 'react';
import { useLocation, useNavigate, useParams } from "react-router";
import { useTranslation } from 'react-i18next';
import { Location } from 'history';
import { callNativeWeb, footerShowEventWeb } from 'common/appInterface';
import { WEBVIEW_RESOURCE_VERSION } from 'common/cacheOverwrite';

const BenefitsDetailPage: React.FC = () => {
  /** Location State */
  const location = useLocation() as Location<LocationState>;
  /** Navigate */
  const navigate = useNavigate();
  /** Params */
  const { cardProductCode } = useParams();
  /** 다국어처리 */
  const { t, i18n } = useTranslation();

  const screenId = "APPL02";
  const screenName = t("APPL02.title");

  /** backKeyEvent_App 처리 (APP > WEB) */
  const callbackBackkeyEvent = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  // 최초실행
  useEffect(() => {
    // 언어설정
    i18n.changeLanguage(location.state.query.languageCode);
    // callNative_Web 처리 (WEB > APP)
    callNativeWeb(screenId, screenName);
    // 하단바 숨기기
    footerShowEventWeb("N");

    console.log("QUERY STATE");
    console.log(location.state);

    // 최초한번실행 useEffect() Warning 제거
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    document.addEventListener("backpress", callbackBackkeyEvent);
    return () => document.removeEventListener("backpress", callbackBackkeyEvent);
  }, [callbackBackkeyEvent]);

  return (
    <div id="wrap">
      <div id="container" className="pcHidden">
        <iframe
          className="productDetail"
          src={`${process.env.REACT_APP_OUTER_HTML_PATH}/card/benefit/${cardProductCode}/detail/card_detail_benefit.html?v=${WEBVIEW_RESOURCE_VERSION}&lang=${location.state.query.languageCode}`}
          allowFullScreen={true}
          title={`카드상품상세_${cardProductCode}`}
        />
        <div className="btnArea">
          <div className="btnWrapTy01">
            <button
              type="button"
              className="btnPrimaryTy01"
              onClick={() => navigate(-1)}>
              <span>{t('COMMON.button.done')}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitsDetailPage;